import { stdChannel } from './channel';
import { runSaga } from './runSaga';

const _channel = stdChannel();
const createSaga = () => {
	let boundRunSaga;
	const SagaMiddleware = ({ getState, dispatch }) => {
		boundRunSaga = runSaga.bind(null, {
			getState,
			dispatch,
			channel: _channel,
		});

		return (next) => (action) => {
			const result = next(action);
			_channel.put(action);
			return result;
		};
	};
	SagaMiddleware.run = (...args) => {
		return boundRunSaga(...args);
	};
	return SagaMiddleware;
};
export default createSaga;
